export const demoVideos = [
  {
    id: '1',
    title: '15-Minute Morning Yoga Flow',
    description: 'Start your day with energy and focus with this gentle yoga routine designed for all skill levels. Perfect for beginners and those looking for a quick morning practice.',
    duration: '15:00',
    publishDate: 'March 10, 2024',
    youtubeId: 'dQw4w9WgXcQ', // Rick Roll for demo purposes
    instructor: {
      name: 'Lisa Martinez',
      title: 'Certified Yoga Instructor',
      avatar: 'LM'
    },
    chapters: [
      {
        number: 1,
        title: 'Warm-up & Breathing',
        duration: '3:00',
        startTime: '0:00'
      },
      {
        number: 2,
        title: 'Sun Salutations',
        duration: '5:00',
        startTime: '3:00'
      },
      {
        number: 3,
        title: 'Standing Poses',
        duration: '4:00',
        startTime: '8:00'
      },
      {
        number: 4,
        title: 'Cool Down & Meditation',
        duration: '3:00',
        startTime: '12:00'
      }
    ],
    tags: [ 'Yoga', 'Morning Routine', 'Beginner Friendly', '15 Minutes', 'Energy' ],
    relatedVideos: [
      {
        id: '2',
        title: 'Meditation for Beginners',
        duration: '10:00',
        thumbnail: '🧘'
      },
      {
        id: '3',
        title: 'Desk Stretches for Office Workers',
        duration: '12:00',
        thumbnail: '💪'
      }
    ]
  },
  {
    id: '2',
    title: 'Meditation for Beginners',
    description: 'Learn the fundamentals of meditation with this gentle introduction to mindfulness practice. Perfect for those new to meditation or looking to establish a regular practice.',
    duration: '10:00',
    publishDate: 'March 8, 2024',
    youtubeId: 'dQw4w9WgXcQ',
    instructor: {
      name: 'Dr. Sarah Chen',
      title: 'Mindfulness Meditation Teacher',
      avatar: 'SC'
    },
    chapters: [
      {
        number: 1,
        title: 'Introduction to Meditation',
        duration: '2:00',
        startTime: '0:00'
      },
      {
        number: 2,
        title: 'Breathing Awareness',
        duration: '3:00',
        startTime: '2:00'
      },
      {
        number: 3,
        title: 'Body Scan Practice',
        duration: '3:00',
        startTime: '5:00'
      },
      {
        number: 4,
        title: 'Closing & Reflection',
        duration: '2:00',
        startTime: '8:00'
      }
    ],
    tags: [ 'Meditation', 'Mindfulness', 'Beginner', 'Stress Relief', 'Mental Health' ],
    relatedVideos: [
      {
        id: '1',
        title: '15-Minute Morning Yoga Flow',
        duration: '15:00',
        thumbnail: '🧘'
      },
      {
        id: '4',
        title: 'Evening Relaxation Yoga',
        duration: '20:00',
        thumbnail: '🌙'
      }
    ]
  },
  {
    id: '3',
    title: 'Desk Stretches for Office Workers',
    description: 'Combat the effects of prolonged sitting with these simple stretches you can do at your desk. Perfect for office workers and anyone who sits for long periods.',
    duration: '12:00',
    publishDate: 'March 6, 2024',
    youtubeId: 'dQw4w9WgXcQ',
    instructor: {
      name: 'Mike Rodriguez',
      title: 'Physical Therapist & Ergonomics Specialist',
      avatar: 'MR'
    },
    chapters: [
      {
        number: 1,
        title: 'Neck & Shoulder Stretches',
        duration: '3:00',
        startTime: '0:00'
      },
      {
        number: 2,
        title: 'Back & Spine Mobility',
        duration: '3:00',
        startTime: '3:00'
      },
      {
        number: 3,
        title: 'Hip & Leg Stretches',
        duration: '3:00',
        startTime: '6:00'
      },
      {
        number: 4,
        title: 'Wrist & Hand Exercises',
        duration: '3:00',
        startTime: '9:00'
      }
    ],
    tags: [ 'Office Health', 'Stretching', 'Ergonomics', 'Back Pain', 'Workplace Wellness' ],
    relatedVideos: [
      {
        id: '1',
        title: '15-Minute Morning Yoga Flow',
        duration: '15:00',
        thumbnail: '🧘'
      },
      {
        id: '5',
        title: 'Quick Energy Boost Workout',
        duration: '8:00',
        thumbnail: '⚡'
      }
    ]
  },
  {
    id: '4',
    title: 'Evening Relaxation Yoga',
    description: 'Wind down your day with this calming yoga sequence designed to promote relaxation and better sleep. Perfect for evening practice.',
    duration: '20:00',
    publishDate: 'March 4, 2024',
    youtubeId: 'dQw4w9WgXcQ',
    instructor: {
      name: 'Emma Thompson',
      title: 'Restorative Yoga Instructor',
      avatar: 'ET'
    },
    chapters: [
      {
        number: 1,
        title: 'Gentle Warm-up',
        duration: '4:00',
        startTime: '0:00'
      },
      {
        number: 2,
        title: 'Forward Folds & Twists',
        duration: '6:00',
        startTime: '4:00'
      },
      {
        number: 3,
        title: 'Hip Openers',
        duration: '5:00',
        startTime: '10:00'
      },
      {
        number: 4,
        title: 'Restorative Poses',
        duration: '3:00',
        startTime: '15:00'
      },
      {
        number: 5,
        title: 'Final Relaxation',
        duration: '2:00',
        startTime: '18:00'
      }
    ],
    tags: [ 'Evening Yoga', 'Relaxation', 'Sleep', 'Restorative', 'Stress Relief' ],
    relatedVideos: [
      {
        id: '2',
        title: 'Meditation for Beginners',
        duration: '10:00',
        thumbnail: '🧘'
      },
      {
        id: '6',
        title: 'Breathing Exercises for Sleep',
        duration: '15:00',
        thumbnail: '😴'
      }
    ]
  },
  {
    id: '5',
    title: 'Quick Energy Boost Workout',
    description: 'Get your blood flowing and energy up with this short, high-intensity workout. Perfect for a midday pick-me-up or when you need a quick energy boost.',
    duration: '8:00',
    publishDate: 'March 2, 2024',
    youtubeId: 'dQw4w9WgXcQ',
    instructor: {
      name: 'Alex Johnson',
      title: 'HIIT Specialist & Personal Trainer',
      avatar: 'AJ'
    },
    chapters: [
      {
        number: 1,
        title: 'Warm-up',
        duration: '1:00',
        startTime: '0:00'
      },
      {
        number: 2,
        title: 'High Knees & Jumping Jacks',
        duration: '2:00',
        startTime: '1:00'
      },
      {
        number: 3,
        title: 'Burpees & Mountain Climbers',
        duration: '2:00',
        startTime: '3:00'
      },
      {
        number: 4,
        title: 'Squats & Lunges',
        duration: '2:00',
        startTime: '5:00'
      },
      {
        number: 5,
        title: 'Cool-down',
        duration: '1:00',
        startTime: '7:00'
      }
    ],
    tags: [ 'HIIT', 'Energy', 'Quick Workout', 'Cardio', 'Fitness' ],
    relatedVideos: [
      {
        id: '3',
        title: 'Desk Stretches for Office Workers',
        duration: '12:00',
        thumbnail: '💪'
      },
      {
        id: '7',
        title: 'Full Body Strength Training',
        duration: '25:00',
        thumbnail: '🏋️'
      }
    ]
  },
  {
    id: '6',
    title: 'Breathing Exercises for Sleep',
    description: 'Learn powerful breathing techniques specifically designed to help you fall asleep faster and sleep more soundly. Perfect for those struggling with insomnia.',
    duration: '15:00',
    publishDate: 'February 28, 2024',
    youtubeId: 'dQw4w9WgXcQ',
    instructor: {
      name: 'Dr. Michael Park',
      title: 'Sleep Medicine Specialist',
      avatar: 'MP'
    },
    chapters: [
      {
        number: 1,
        title: 'Introduction to Sleep Breathing',
        duration: '2:00',
        startTime: '0:00'
      },
      {
        number: 2,
        title: '4-7-8 Breathing Technique',
        duration: '4:00',
        startTime: '2:00'
      },
      {
        number: 3,
        title: 'Box Breathing for Sleep',
        duration: '4:00',
        startTime: '6:00'
      },
      {
        number: 4,
        title: 'Progressive Muscle Relaxation',
        duration: '3:00',
        startTime: '10:00'
      },
      {
        number: 5,
        title: 'Guided Sleep Meditation',
        duration: '2:00',
        startTime: '13:00'
      }
    ],
    tags: [ 'Sleep', 'Breathing', 'Insomnia', 'Relaxation', 'Meditation' ],
    relatedVideos: [
      {
        id: '4',
        title: 'Evening Relaxation Yoga',
        duration: '20:00',
        thumbnail: '🌙'
      },
      {
        id: '8',
        title: 'Sleep Hygiene Tips',
        duration: '12:00',
        thumbnail: '🛏️'
      }
    ]
  },
  {
    id: '7',
    title: 'Full Body Strength Training',
    description: 'Build strength and muscle with this comprehensive full-body workout using only your body weight. No equipment needed!',
    duration: '25:00',
    publishDate: 'February 26, 2024',
    youtubeId: 'dQw4w9WgXcQ',
    instructor: {
      name: 'Jessica Williams',
      title: 'Strength & Conditioning Coach',
      avatar: 'JW'
    },
    chapters: [
      {
        number: 1,
        title: 'Dynamic Warm-up',
        duration: '5:00',
        startTime: '0:00'
      },
      {
        number: 2,
        title: 'Upper Body Circuit',
        duration: '6:00',
        startTime: '5:00'
      },
      {
        number: 3,
        title: 'Lower Body Circuit',
        duration: '6:00',
        startTime: '11:00'
      },
      {
        number: 4,
        title: 'Core & Stability',
        duration: '5:00',
        startTime: '17:00'
      },
      {
        number: 5,
        title: 'Cool-down & Stretching',
        duration: '3:00',
        startTime: '22:00'
      }
    ],
    tags: [ 'Strength Training', 'Full Body', 'Bodyweight', 'Muscle Building', 'Fitness' ],
    relatedVideos: [
      {
        id: '5',
        title: 'Quick Energy Boost Workout',
        duration: '8:00',
        thumbnail: '⚡'
      },
      {
        id: '9',
        title: 'Beginner\'s Guide to Fitness',
        duration: '18:00',
        thumbnail: '🎯'
      }
    ]
  },
  {
    id: '8',
    title: 'Sleep Hygiene Tips',
    description: 'Learn evidence-based strategies to improve your sleep quality and establish healthy sleep habits that will last a lifetime.',
    duration: '12:00',
    publishDate: 'February 24, 2024',
    youtubeId: 'dQw4w9WgXcQ',
    instructor: {
      name: 'Dr. Lisa Anderson',
      title: 'Sleep Psychologist',
      avatar: 'LA'
    },
    chapters: [
      {
        number: 1,
        title: 'Understanding Sleep Hygiene',
        duration: '2:00',
        startTime: '0:00'
      },
      {
        number: 2,
        title: 'Creating the Perfect Sleep Environment',
        duration: '3:00',
        startTime: '2:00'
      },
      {
        number: 3,
        title: 'Pre-Sleep Routine',
        duration: '3:00',
        startTime: '5:00'
      },
      {
        number: 4,
        title: 'Managing Technology & Light',
        duration: '2:00',
        startTime: '8:00'
      },
      {
        number: 5,
        title: 'Troubleshooting Common Issues',
        duration: '2:00',
        startTime: '10:00'
      }
    ],
    tags: [ 'Sleep Hygiene', 'Sleep Quality', 'Healthy Habits', 'Wellness', 'Health' ],
    relatedVideos: [
      {
        id: '6',
        title: 'Breathing Exercises for Sleep',
        duration: '15:00',
        thumbnail: '😴'
      },
      {
        id: '10',
        title: 'Managing Sleep Disorders',
        duration: '20:00',
        thumbnail: '🏥'
      }
    ]
  },
  {
    id: '9',
    title: 'Beginner\'s Guide to Fitness',
    description: 'Start your fitness journey with confidence! This comprehensive guide covers everything you need to know to begin exercising safely and effectively.',
    duration: '18:00',
    publishDate: 'February 22, 2024',
    youtubeId: 'dQw4w9WgXcQ',
    instructor: {
      name: 'David Kim',
      title: 'Certified Personal Trainer & Fitness Educator',
      avatar: 'DK'
    },
    chapters: [
      {
        number: 1,
        title: 'Setting Realistic Goals',
        duration: '3:00',
        startTime: '0:00'
      },
      {
        number: 2,
        title: 'Basic Exercise Principles',
        duration: '4:00',
        startTime: '3:00'
      },
      {
        number: 3,
        title: 'Cardio vs Strength Training',
        duration: '3:00',
        startTime: '7:00'
      },
      {
        number: 4,
        title: 'Proper Form & Safety',
        duration: '4:00',
        startTime: '10:00'
      },
      {
        number: 5,
        title: 'Creating Your First Workout',
        duration: '4:00',
        startTime: '14:00'
      }
    ],
    tags: [ 'Fitness Basics', 'Beginner', 'Exercise Education', 'Health', 'Wellness' ],
    relatedVideos: [
      {
        id: '7',
        title: 'Full Body Strength Training',
        duration: '25:00',
        thumbnail: '🏋️'
      },
      {
        id: '1',
        title: '15-Minute Morning Yoga Flow',
        duration: '15:00',
        thumbnail: '🧘'
      }
    ]
  },
  {
    id: '10',
    title: 'Managing Sleep Disorders',
    description: 'Learn about common sleep disorders, their causes, and evidence-based treatment options. Important information for anyone struggling with sleep issues.',
    duration: '20:00',
    publishDate: 'February 20, 2024',
    youtubeId: 'dQw4w9WgXcQ',
    instructor: {
      name: 'Dr. Robert Taylor',
      title: 'Sleep Medicine Physician',
      avatar: 'RT'
    },
    chapters: [
      {
        number: 1,
        title: 'Understanding Sleep Disorders',
        duration: '4:00',
        startTime: '0:00'
      },
      {
        number: 2,
        title: 'Insomnia: Causes & Treatments',
        duration: '4:00',
        startTime: '4:00'
      },
      {
        number: 3,
        title: 'Sleep Apnea & Breathing Issues',
        duration: '4:00',
        startTime: '8:00'
      },
      {
        number: 4,
        title: 'Restless Leg Syndrome',
        duration: '3:00',
        startTime: '12:00'
      },
      {
        number: 5,
        title: 'When to Seek Professional Help',
        duration: '3:00',
        startTime: '15:00'
      },
      {
        number: 6,
        title: 'Treatment Options & Resources',
        duration: '2:00',
        startTime: '18:00'
      }
    ],
    tags: [ 'Sleep Disorders', 'Medical Information', 'Health Education', 'Sleep Medicine', 'Wellness' ],
    relatedVideos: [
      {
        id: '8',
        title: 'Sleep Hygiene Tips',
        duration: '12:00',
        thumbnail: '🛏️'
      },
      {
        id: '6',
        title: 'Breathing Exercises for Sleep',
        duration: '15:00',
        thumbnail: '😴'
      }
    ]
  }
];
